import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_MEDREFILL_PRESCRIPTIONS_LIST_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetPrescriptionListPayload, GetPrescriptionListResult } from '../types/getPrescriptionList.type';

export const TAG_MEDREFILL_PRESCRIPTION_LIST = 'getPrescriptionList';

export const getPrescriptionList = <T extends BuilderType>(builder: T) =>
  builder.query<GetPrescriptionListResult, GetPrescriptionListPayload>({
    providesTags: [TAG_MEDREFILL_PRESCRIPTION_LIST],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_MEDREFILL_PRESCRIPTIONS_LIST_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetPrescriptionListResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
